import { render, staticRenderFns } from "./FramelessTitlebar.vue?vue&type=template&id=0a6adce1&scoped=true&"
import script from "./FramelessTitlebar.vue?vue&type=script&lang=js&"
export * from "./FramelessTitlebar.vue?vue&type=script&lang=js&"
import style0 from "./FramelessTitlebar.vue?vue&type=style&index=0&id=0a6adce1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6adce1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a6adce1')) {
      api.createRecord('0a6adce1', component.options)
    } else {
      api.reload('0a6adce1', component.options)
    }
    module.hot.accept("./FramelessTitlebar.vue?vue&type=template&id=0a6adce1&scoped=true&", function () {
      api.rerender('0a6adce1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FramelessTitlebar.vue"
export default component.exports